import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartialDamageReportCreateService } from './partial-damage-report-create/partial-damage-report-create.service';
import { PartialDamageReportLatestDetailService } from './partial-damage-report-latest-detail/partial-damage-report-latest-detail.service';
import { PartialDamageReportsListService } from './partial-damage-reports-list/partial-damage-reports-list.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    PartialDamageReportCreateService,
    PartialDamageReportLatestDetailService,
    PartialDamageReportsListService,
  ],
})
export class PartialDamageReportsModule {}